import {
    WKF_CTA_BUTTON, WKF_CTA_SUBTITLE, WKF_CTA_TITLE,
    WKF_DISCLAIMER_BODY, WKF_DISCLAIMER_EYEBROW, WKF_DISCLAIMER_TITLE,
    WKF_FAQ_A1, WKF_FAQ_A2, WKF_FAQ_A3, WKF_FAQ_A4, WKF_FAQ_A5,
    WKF_FAQ_EYEBROW, WKF_FAQ_Q1, WKF_FAQ_Q2, WKF_FAQ_Q3, WKF_FAQ_Q4, WKF_FAQ_Q5,
    WKF_FAQ_SUBTITLE, WKF_FAQ_TITLE,
    WKF_HELMET_DESCRIPTION, WKF_HELMET_TITLE,
    WKF_HERO_CTA_BOOK, WKF_HERO_CTA_CALL, WKF_HERO_EYEBROW, WKF_HERO_SUBTITLE,
    WKF_HERO_TITLE, WKF_HERO_TITLE_ACCENT,
    WKF_HERO_TRUST_BILINGUAL, WKF_HERO_TRUST_FAMILIES, WKF_HERO_TRUST_LOCAL,
    WKF_PROCESS_EYEBROW,
    WKF_PROCESS_STEP1_DESC, WKF_PROCESS_STEP1_TITLE,
    WKF_PROCESS_STEP2_DESC, WKF_PROCESS_STEP2_TITLE,
    WKF_PROCESS_STEP3_DESC, WKF_PROCESS_STEP3_TITLE,
    WKF_PROCESS_STEP4_DESC, WKF_PROCESS_STEP4_TITLE,
    WKF_PROCESS_TITLE,
    WKF_SERVICES_EYEBROW, WKF_SERVICES_SUBTITLE, WKF_SERVICES_TITLE,
    WKF_SERVICE_APPLICATIONS_DESC, WKF_SERVICE_APPLICATIONS_TITLE,
    WKF_SERVICE_INTERVIEW_DESC, WKF_SERVICE_INTERVIEW_TITLE,
    WKF_SERVICE_JOBSEARCH_DESC, WKF_SERVICE_JOBSEARCH_TITLE,
    WKF_SERVICE_REFERRAL_DESC, WKF_SERVICE_REFERRAL_TITLE,
    WKF_SERVICE_RESUME_DESC, WKF_SERVICE_RESUME_TITLE,
    WKF_SERVICE_TRAINING_DESC, WKF_SERVICE_TRAINING_TITLE,
} from "../types";

const en_workforce_page = {
    helmet: {
        [WKF_HELMET_TITLE]: "Workforce & job search help in English & Spanish | Linares Pro Corp",
        [WKF_HELMET_DESCRIPTION]: "Bilingual help building resumes, finding jobs, completing applications, preparing for interviews, and connecting with training programs.",
    },
    section: {
        hero: {
            [WKF_HERO_EYEBROW]: "Workforce services",
            [WKF_HERO_TITLE]: "Find your next job,",
            [WKF_HERO_TITLE_ACCENT]: "with someone in your corner.",
            [WKF_HERO_SUBTITLE]: "We help you put together a strong resume, apply to real jobs, and walk into your interview ready — in English or Spanish.",
            [WKF_HERO_CTA_BOOK]: "Start with us",
            [WKF_HERO_CTA_CALL]: "Call now",
            [WKF_HERO_TRUST_BILINGUAL]: "English & Spanish",
            [WKF_HERO_TRUST_LOCAL]: "Local opportunities",
            [WKF_HERO_TRUST_FAMILIES]: "We work with families",
        },
        services: {
            [WKF_SERVICES_EYEBROW]: "What we help with",
            [WKF_SERVICES_TITLE]: "Real support to get hired.",
            [WKF_SERVICES_SUBTITLE]: "Practical help from the resume to the first day — not just generic advice.",
            [WKF_SERVICE_RESUME_TITLE]: "Resume building",
            [WKF_SERVICE_RESUME_DESC]: "We write or update your resume so it shows your real experience clearly, in English or Spanish.",
            [WKF_SERVICE_JOBSEARCH_TITLE]: "Job search assistance",
            [WKF_SERVICE_JOBSEARCH_DESC]: "We help you find local job postings that fit your experience and your schedule.",
            [WKF_SERVICE_APPLICATIONS_TITLE]: "Job applications",
            [WKF_SERVICE_APPLICATIONS_DESC]: "We sit with you and complete online or paper applications so nothing is missed.",
            [WKF_SERVICE_INTERVIEW_TITLE]: "Interview preparation",
            [WKF_SERVICE_INTERVIEW_DESC]: "We practice common questions and help you feel confident about what to say and how to dress.",
            [WKF_SERVICE_TRAINING_TITLE]: "Training & certifications",
            [WKF_SERVICE_TRAINING_DESC]: "We connect you with classes and certifications that can open the door to better jobs.",
            [WKF_SERVICE_REFERRAL_TITLE]: "Employer referrals",
            [WKF_SERVICE_REFERRAL_DESC]: "When we know an employer who is hiring, we make the introduction for you.",
        },
        process: {
            [WKF_PROCESS_EYEBROW]: "How it works",
            [WKF_PROCESS_TITLE]: "A clear plan to get you hired.",
            [WKF_PROCESS_STEP1_TITLE]: "Free conversation",
            [WKF_PROCESS_STEP1_DESC]: "Tell us your experience, your skills, and what kind of job you're looking for.",
            [WKF_PROCESS_STEP2_TITLE]: "Build the resume",
            [WKF_PROCESS_STEP2_DESC]: "We prepare a clean, honest resume that highlights what you actually bring to the job.",
            [WKF_PROCESS_STEP3_TITLE]: "Apply together",
            [WKF_PROCESS_STEP3_DESC]: "We help you apply to the right openings and follow up so you're not ignored.",
            [WKF_PROCESS_STEP4_TITLE]: "Prepare for the interview",
            [WKF_PROCESS_STEP4_DESC]: "We practice with you so you walk in calm, prepared, and ready to be hired.",
        },
        faq: {
            [WKF_FAQ_EYEBROW]: "Workforce FAQ",
            [WKF_FAQ_TITLE]: "Common questions.",
            [WKF_FAQ_SUBTITLE]: "Got something not listed here? Just call — we love these conversations.",
            [WKF_FAQ_Q1]: "Can you help me if I don't have any work experience in the U.S.?",
            [WKF_FAQ_A1]: "Yes. We help you present the experience you do have — at home, abroad, or in informal work — in a way that employers respect.",
            [WKF_FAQ_Q2]: "Do I need to speak English to apply?",
            [WKF_FAQ_A2]: "Many jobs accept bilingual or Spanish-speaking workers. We help you target the openings that match your level.",
            [WKF_FAQ_Q3]: "Do you guarantee a job?",
            [WKF_FAQ_A3]: "No one can honestly guarantee that. What we guarantee is real preparation and real applications, not empty promises.",
            [WKF_FAQ_Q4]: "Do you charge for resumes?",
            [WKF_FAQ_A4]: "Our document fees are very affordable. We'll quote you up front, before any work begins.",
            [WKF_FAQ_Q5]: "Do you help with training programs?",
            [WKF_FAQ_A5]: "Yes. We point you to local courses and certifications and help you with the paperwork to enroll.",
        },
        cta: {
            [WKF_CTA_TITLE]: "Your next job is closer than you think.",
            [WKF_CTA_SUBTITLE]: "Come in with whatever you have — we'll build the rest with you.",
            [WKF_CTA_BUTTON]: "Call now",
        },
        disclaimer: {
            [WKF_DISCLAIMER_EYEBROW]: "Important notice",
            [WKF_DISCLAIMER_TITLE]: "We help you prepare — we are not the employer or government agency.",
            [WKF_DISCLAIMER_BODY]: "Linares Pro Family Service Corp is an independent document-preparation and translation service. We are not a state workforce office, recruiting agency, or guarantor of employment. We do not promise any job, position, or hiring decision. All hiring decisions are made solely by employers, and all official benefits decisions are made solely by the corresponding government agency.",
        },
    },
};

export default en_workforce_page;
